import React from 'react';
import { 
  CalculatorIcon, 
  DocumentCheckIcon, 
  ArrowPathIcon, 
  ChartBarSquareIcon, 
  FolderOpenIcon, 
  CodeBracketIcon 
} from '@heroicons/react/24/outline';
import { Container } from '../common/Container';

const features = [
  {
    Icon: CalculatorIcon,
    title: 'Multiple Valuation Methods',
    description: 'Cost approach, income-based analysis, and equity comparables all in one platform for comprehensive property assessments.'
  },
  {
    Icon: DocumentCheckIcon,
    title: 'Comprehensive Workups',
    description: 'Generate court-ready documentation with all valuation approaches and supporting evidence in minutes.'
  },
  {
    Icon: ArrowPathIcon,
    title: 'Complete Appeal Tracking',
    description: 'Track every appeal from notice to litigation with automated workflows, status updates, and full data persistence across all stages.'
  },
  {
    Icon: CodeBracketIcon,
    title: 'Enterprise API Integration',
    description: 'Seamlessly integrate with your existing systems using our REST API. Full programmatic access to property data, appeals, and reporting.'
  },
  {
    Icon: ChartBarSquareIcon,
    title: 'Analytics & Reporting',
    description: 'Real-time dashboards showing appeal status, savings calculations, and performance metrics across your entire portfolio.'
  },
  {
    Icon: FolderOpenIcon,
    title: 'Document Management',
    description: 'Centralized storage for rent rolls, income statements, photos, and all property documents with version control.'
  }
];

export const Features: React.FC = () => {
  return (
    <section className="py-24 bg-white">
      <Container>
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-brand-blue mb-4">
            Everything You Need to Win Appeals
          </h2>
          <p className="text-xl text-brand-white-600 max-w-3xl mx-auto">
            Powerful features built specifically for property tax professionals
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="flex flex-col p-6 rounded-lg hover:bg-brand-blue-50 transition-colors"
            >
              <div className="w-12 h-12 bg-brand-red rounded-lg flex items-center justify-center mb-4">
                <feature.Icon className="w-6 h-6 text-white" />
              </div>
              
              <h3 className="text-xl font-bold text-brand-blue mb-2">
                {feature.title}
              </h3>
              
              <p className="text-brand-white-600">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

